import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

import DeliveryPackingFormRoute from './PackingForm';

const routes: CustomRoute = {
	path: appPath.logistics,
	components: () => [],
	render: (_, children) => children,
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'Delivery' */ './component')],
			render: ([Delivery]) => <Delivery />,
		},
		DeliveryPackingFormRoute,
	],
};

export default routes;
